import React from "react";
import styled from "styled-components";
import { Section, Panel, Eyebrow, H2, Lead, CenteredHead } from "../components/ui";

const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;

  @media screen and (max-width: 64em) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 30em) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  padding: 1.75rem 1.5rem;
  border-radius: 20px;
  background: #ffffff;

  svg {
    width: 28px;
    height: 28px;
    color: #0a7a53;
    margin-bottom: 1.25rem;
  }

  h3 {
    font-family: var(--fontL);
    font-size: 1.125rem;
    font-weight: 500;
    letter-spacing: -0.01em;
    margin-bottom: 0.5rem;
  }

  p {
    font-family: var(--fontR);
    font-size: 0.9375rem;
    line-height: 1.55;
    color: var(--text-lo);
  }
`;

const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

const ITEMS = [
  {
    title: "Connexion par Powens",
    text: "Tes comptes sont reliés par Powens, l'un des grands acteurs européens de la connexion bancaire, agréé et régulé. Nea ne voit jamais tes identifiants.",
    icon: (
      <Icon>
        <path d="M3 10l9-6 9 6" />
        <path d="M5 10v8M9.5 10v8M14.5 10v8M19 10v8M3 20h18" />
      </Icon>
    ),
  },
  {
    title: "Lecture seule",
    text: "Nea lit tes opérations pour te les expliquer. Elle ne peut ni faire un virement, ni déplacer un euro.",
    icon: (
      <Icon>
        <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
        <circle cx="12" cy="12" r="3" />
      </Icon>
    ),
  },
  {
    title: "Données chiffrées",
    text: "Tes données sont chiffrées pendant leur transport et là où elles sont stockées.",
    icon: (
      <Icon>
        <rect x="4" y="11" width="16" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 018 0v4" />
      </Icon>
    ),
  },
  {
    title: "Jamais revendues",
    text: "Pas de revente de données, pas de commission sur des produits financiers. Notre seul client, c'est toi.",
    icon: (
      <Icon>
        <path d="M12 3l8 3v6c0 4.5-3.2 8-8 9-4.8-1-8-4.5-8-9V6l8-3z" />
        <path d="M9 12l2 2 4-4" />
      </Icon>
    ),
  },
];

const Security = () => (
  <Section id="securite">
    <Panel data-reveal>
      <CenteredHead>
        <Eyebrow>Sécurité</Eyebrow>
        <H2>Ta banque reste ta banque.</H2>
        <Lead style={{ maxWidth: "38rem" }}>
          Connecter ses comptes, ça se mérite. Voici exactement ce que Nea peut faire avec les tiens, et ce qu'elle ne
          peut pas faire.
        </Lead>
      </CenteredHead>

      <Cards>
        {ITEMS.map((item) => (
          <Card key={item.title}>
            {item.icon}
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </Card>
        ))}
      </Cards>
    </Panel>
  </Section>
);

export default Security;
